// Zentrale Versions-Konstante. Bei Releases hier aktualisieren.
// Format: "MAJOR.MINOR.PATCH (Build YYMMDDHHmm)" in Europe/Berlin
export const APP_VERSION = "1.3.3 (Build 2607281902)";
